import React from 'react';
import FormLayout from '../../layout/Form/FormLayout';
import { VerticalStepper } from '../../Stepper';
import { FormInStepperBuilder, formInStepperBuilder } from '../helpers';
import { FormikContextType } from 'formik';

interface IStepperForm {
  form: FormInStepperBuilder[],
  formik: FormikContextType<any>
}

const FormStepperBuilder = ({form, formik}: IStepperForm) => {
  return (
    <FormLayout>
      <VerticalStepper activeStep={1}>
        {formInStepperBuilder(form, formik)}
      </VerticalStepper>
    </FormLayout>
  );
};

export default FormStepperBuilder;